import axios from "axios";

// ErrorCodesConstants.INTERNAL_SERVER_EXCEPTION: the `type` of the API's generic 500, whose title is English boilerplate.
const INTERNAL_SERVER_ERROR_CODE = "AISE000";

// The API answers its own errors (ValidationException, ResourceNotFound...) as ProblemDetails: `title` is the Polish
// message, `type` the error code. Framework-generated problems have an RFC URL as `type` and an English title.
const readableTitle = (data: { title?: unknown; type?: unknown }): string | null => {
  if (typeof data.title !== "string" || data.title.trim() === "") return null;
  if (typeof data.type === "string" && (data.type === INTERNAL_SERVER_ERROR_CODE || /^https?:\/\//i.test(data.type))) {
    return null;
  }
  return data.title;
};

// A request made with responseType "arraybuffer" (extra page / asset / photo downloads) delivers even its error body as raw
// bytes: decode a JSON one so its message is not lost. toString check, not instanceof: it also holds across realms.
const readBody = (data: unknown): unknown => {
  const tag = Object.prototype.toString.call(data);
  if (tag !== "[object ArrayBuffer]" && !ArrayBuffer.isView(data)) return data;
  try {
    return JSON.parse(new TextDecoder().decode(data as BufferSource));
  } catch {
    return null;
  }
};

export const getApiErrorMessage = (error: unknown, fallback: string): string => {
  if (!axios.isAxiosError(error)) return fallback;

  const data = readBody(error.response?.data) as { message?: unknown; title?: unknown; type?: unknown } | null | undefined;
  if (typeof data?.message === "string") return data.message;
  if (data && typeof data === "object") return readableTitle(data) ?? fallback;
  return fallback;
};
